import { SIMPLVmTable } from "../../SimplVmTable";

export const SIMPLVmPolicies = () => (
  <SIMPLVmTable
    type="policies"
    addButtonLabel="Add Policy"
    addModalTitle="VM Policies"
    contentLabel="Rules"
    contentMessage="Rules are required"
  />
);